import React from 'react';

import { Form } from 'semantic-ui-react';

import jwt_decode from 'jwt-decode';

export default class Login extends React.Component {
  constructor() {
    super();
    this.initialState = {
      username: '',
      password: '',
      loggedInAs: '',
      loggingIn: false
    };
    this.state = Object.assign(this.initialState);

    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    const loggedInAs = localStorage.getItem('token') ? jwt_decode(localStorage.getItem('token')).email : '';
    this.setState({
      ...this.initialState,
      loggedInAs: loggedInAs
    });
  }

  fetchToken() {
    const url = 'https://spaces.nexudus.com/api/sys/users/token';
    return fetch(url, {
      method: 'POST',
      headers: new Headers({
        'content-type': 'application/json'
      }),
      body: JSON.stringify({
        email: this.state.username,
        password: this.state.password,
        validityInMinutes: 30
      })
    })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }
      return response.json();
    })
    .catch(error => alert(error));
  }

  handleLogin() {

    this.setState({
      loggingIn: true
    });

    this.fetchToken()
      .then(response => {
        console.log(response);
        // Nexudus will respond 200 to a bad login, but will not provide a token
        if (!response.Value) {
          this.setState(this.initialState);
          return alert('The username or password is incorrect');
        }

        localStorage.setItem('token', response.Value);
        this.setState({
          ...this.initialState,
          loggedInAs: jwt_decode(response.Value).email
        });
      });
  }

  handleLogout() {
    localStorage.removeItem('token');
    this.setState(this.initialState);
    window.location.reload();
  }

  handleChange(e, { name, value }) {
    this.setState({
      [name]: value
    });
  }

  render() {

    return(
      <div>
        {this.state.loggedInAs &&
          <Form onSubmit={this.handleLogout}>
            <Form.Group>
              <Form.Button label={"You are logged in as " + this.state.loggedInAs} name="logout" negative>Logout</Form.Button>
            </Form.Group>
          </Form>
        }
        {!this.state.loggedInAs &&
          <Form loading={this.state.loggingIn} onSubmit={this.handleLogin}>
            <Form.Group>
              <Form.Input onChange={this.handleChange} name="username" value={this.state.username} placeholder="username" />
              <Form.Input onChange={this.handleChange} name="password" type="password" value={this.state.password} placeholder="password" />
              <Form.Button name="login" positive type="submit">Login</Form.Button>
            </Form.Group>
          </Form>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Login.js